import React, { useCallback } from 'react';

import { InputWrapperProps, SelectOption } from '../../../types';
import SelectLabelValueOption from '../common/SelectLabelValueOption';
import { GARNER_SPECIALTIES } from '../../../consts/teladoc-garner/garnerSpecialties';

import './index.less';

interface SpecialtyInputWrapperProps extends InputWrapperProps<'specialty'> {
  validationError?: string;
  isDirty?: boolean;
}

export const SpecialtyInputWrapper: React.FC<SpecialtyInputWrapperProps> = ({
  value,
  onChange,
  validationError,
  isDirty,
}) => {
  const onSpecialtyChange = useCallback(
    (newSpecialty: SelectOption) => {
      onChange({
        specialty: {
          searchDisplay: newSpecialty?.label,
          vimSpecialtyId: newSpecialty?.value,
          vimSpecialtyDescription: newSpecialty?.label,
        },
      });
    },
    [onChange],
  );

  return (
    <div className="select-network-input">
      <SelectLabelValueOption
        className="teladoc-garner-select-specialty"
        selected={
          value?.searchDisplay && value?.vimSpecialtyId
            ? {
                label: value.searchDisplay,
                value: value.vimSpecialtyId,
              }
            : undefined
        }
        valueField="label" // value can be duplicated, cannot use it as a key
        isDirty={isDirty}
        validationError={validationError}
        items={GARNER_SPECIALTIES}
        onChange={onSpecialtyChange}
        wrapperProps={{
          className: 'specialty-input-wrapper',
          leftIcon: <i className="icon-stethoscope" />,
        }}
        selectProps={{
          placeholder: 'Specialty',
          id: 'specialty-input',
          name: 'specialty',
          noResultsLabel: 'No specialties found',
        }}
      />
    </div>
  );
};
